/* eslint max-classes-per-file: 0 */

import {
  LkNotificationPage as Data,
  LkNotificationPageCollection as Collection,
} from '@/typings/api/NotificationPage'
import { LkNotificationsPagesApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class LkNotificationPagesTransformerParams extends TransformerParams {
  protected defaultParams = ['url'];
}

export class LkNotificationPagesAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new LkNotificationPagesTransformerParams();
}
